<ion-list lines="none" class="ion-no-padding">
  <ion-item button (click)="sendEvaluation('Accepted')">
    <ion-label class="action-label accept-option"> <fa-icon [icon]="faCheckCircle"></fa-icon>Accepted</ion-label>
  </ion-item>
  <ion-item button (click)="sendEvaluation('Rejected')">
    <ion-label class="action-label reject-option"> <fa-icon [icon]="faExclamationCircle"></fa-icon>Requires resubmission</ion-label>
  </ion-item>
</ion-list>
